import React from "react";
import "./GroupSelectionType.css";

const GroupSelectionType = ({
  value = "all",
  onChange,
  label = "Target Audience",
  disabled = false,
}) => {
  const handleChange = (e) => {
    if (onChange && !disabled) {
      onChange(e.target.value);
    }
  };

  const options = [
    { value: "all", label: "All Groups" },
    { value: "official", label: "Official Supporters Groups" },
    { value: "region", label: "By Region" },
    { value: "country", label: "By Country" },
    { value: "group", label: "Specific Groups" },
  ];

  return (
    <div className="group-audience-type">
      {label && <label className="group-audience-type__label">{label}</label>}
      <div className="group-audience-type__options">
        {options.map((option) => (
          <label key={option.value} className="group-audience-type__option">
            <input
              type="radio"
              name="group-audience-type"
              value={option.value}
              checked={value === option.value}
              onChange={handleChange}
              disabled={disabled}
              className="group-audience-type__radio"
            />
            <span className="group-audience-type__label-text">
              {option.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default GroupSelectionType;
